import React from 'react';
import { styles, colors } from '../../styles/globalStyles';

export const LoadingSpinner = ({ size = 'md', message = 'Carregando...' }) => {
  const sizes = {
    sm: '1.5rem',
    md: '3rem',
    lg: '5rem'
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3rem',
      textAlign: 'center'
    }}>
      <div style={{
        width: sizes[size],
        height: sizes[size],
        border: `3px solid ${colors.grayLight}`,
        borderTopColor: colors.primary,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '1rem'
      }}></div>
      <p style={{ color: colors.gray, margin: 0 }}>{message}</p>
    </div>
  );
};
